import { render } from "./TextWrapper.vue?vue&type=template&id=1b926a4a"
import script from "./TextWrapper.vue?vue&type=script&lang=js"
export * from "./TextWrapper.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__